import { render, staticRenderFns } from "./LabelConfigView.vue?vue&type=template&id=406d54ff"
import script from "./LabelConfigView.vue?vue&type=script&lang=js"
export * from "./LabelConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports